import BaseAccountController from '../../lib/controllers/BaseAccountController';
import queryParameterParser from '../../lib/helpers/queryStringParser';

export default class PurchasedSessionDetailsController extends BaseAccountController {
	public static $inject: string[] = ['$scope', '$window', 'SessionPackageResource'];

	public generalError: string;
	public generalMessage: string;
	public session: ng.resource.IResource<MyAccountApi.ISessionPackage>;

	private readonly $window: ng.IWindowService;
	private readonly SessionPackageResource: MyAccountApi.ISessionPackageResource;

	constructor($scope: ng.IScope, $window: ng.IWindowService, SessionPackageResource: MyAccountApi.ISessionPackageResource) {
		super($scope);

		this.$window = $window;
		this.SessionPackageResource = SessionPackageResource;
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		const packageId = queryParameterParser.getParameterByName(this.$window, 'packageId');
		const tranId = queryParameterParser.getParameterByName(this.$window, 'transactionId');

		if (!packageId || !tranId) {
			this.generalError = 'Missing required parameters packageId and/or transactionId';
			return;
		}

		this.session = this.SessionPackageResource.get({packageId, tranId});
		this.session.$promise.catch(() => {
			this.generalError = 'Server error while loading details for session (transaction ID ' + tranId + ')';
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
